<template>
  <div>
    <template v-if="editable">
      <template v-if="question.content == null">
        <b-row>
          <b-col :cols=3>
            <b-form-input v-on:change="inputAnswer" placeholder="Enter your choice"></b-form-input>
            <!-- <b-form-select v-on:change="inputAnswer" class="mb-3">
                <b-form-select-option selected>Select your choice</b-form-select-option>
                <b-form-select-option v-for="select_item in question.selectOption" :key="select_item.index" :value="select_item.value">{{ select_item.value }}</b-form-select-option>
            </b-form-select> -->
            <!-- <span
              v-for="select_item in question.selectOption"
              :key="select_item.id"
              @click="inputAnswer2(select_item)"
            >
              <b-button
                pill
                variant="light"
                :class="'mx-1 btn__exam btn__exam--spell pl-3 pr-3' + ((inputAnswerSelect === select_item.value) ? ' btn__exam--selected' : '')"
              >
                <span>{{ select_item.value }}</span>
              </b-button>
            </span> -->
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-row>
          <b-col v-if="question.content" :cols=9>
            <div v-html="question.content" class="question__content"></div>
          </b-col>
          <b-col :cols=3>
            <b-form-input v-on:change="inputAnswer" placeholder="Enter your choice"></b-form-input>
            <!-- <b-form-select v-on:change="inputAnswer" class="mb-3">
                <b-form-select-option selected>Select your choice</b-form-select-option>
                <b-form-select-option v-for="select_item in question.selectOption" :key="select_item.index" :value="select_item.value">{{ select_item.value }}</b-form-select-option>
            </b-form-select> -->
            <!-- <span
              v-for="select_item in question.selectOption"
              :key="select_item.id"
              @click="inputAnswer2(select_item)"
            >
              <b-button
                pill
                variant="light"
                :class="'mx-1 btn__exam btn__exam--spell pl-3 pr-3' + ((inputAnswerSelect === select_item.value) ? ' btn__exam--selected' : '')"
              >
                <span>{{ select_item.value }}</span>
              </b-button>
            </span> -->
          </b-col>
        </b-row>
      </template>
    </template>
    <template v-else>
      <template v-if="question.content == null">
        <b-row>
          <b-col v-for="answer in question.answers" :key="answer.id" :cols=2>
            <b-form-input :state="Boolean(response && response.answer != null && answer.text_answer != null && response.answer.toLowerCase() == answer.text_answer.toLowerCase())" :value="response ? response.answer : ''" readonly></b-form-input>
          </b-col>
          <template v-if="response && response.answer != null && answer.text_answer != null && response.answer.toLowerCase() != answer.text_answer.toLowerCase()">
            <b-col :key="answer.id + '.answer'" :cols=2>
              <b-form-input :state="true" :value="answer.text_answer" readonly></b-form-input>
            </b-col>
          </template>
        </b-row>
      </template>
      <template v-else>
        <b-row>
          <b-col :cols=6>
            <div v-html="question.content" class="question__content"></div>
          </b-col>
          
          <b-col v-for="answer in question.answers" :key="answer.id" :cols=2>
            <b-form-input :state="Boolean(response && response.answer != null && answer.text_answer != null && response.answer.toLowerCase() == answer.text_answer.toLowerCase())" :value="response ? response.answer : ''" readonly></b-form-input>
          </b-col>
          <template v-if="response && response.answer != null && answer.text_answer != null && response.answer.toLowerCase() != answer.text_answer.toLowerCase()">
            <b-col :key="answer.id + '.answer'" :cols=2>
              <b-form-input :state="true" :value="answer.text_answer" readonly></b-form-input>
            </b-col>
          </template>
        </b-row>
      </template>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionReadingText',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isSelected: false,
      answer: [],
      inputAnswerSelect: null
    }
  },
  methods: {
    inputAnswer(evt) {
      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer: evt
      })
    },
    inputAnswer2(item) {
      this.inputAnswerSelect = item.value;
      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer: item.value
      })
    },
    selectAnswer(dataAnswer) {
      this.$emit('selectAnswer', dataAnswer)
    }
  }
}
</script>